/*global window,document,theme,WebFont,setInterval,clearInterval,console,jQuery*/
/*eslint no-console: ["off"] */
window.theme = window.theme || {};
document.documentElement.className = document.documentElement.className.replace("no-js", "js");

// var imagesLoaded = require('imagesloaded');
// import lazySizes from 'lazysizes';
var WebFont = require('webfontloader');
import slick from 'slick-carousel';
import featherlight from 'featherlight';
import featherlightGallery from 'featherlight/release/featherlight.gallery.min.js';
// GSAP removed - was only used for section_features_horizontal

(function($) {
	"use strict";

	theme.init = function() {
		// Initialize infinite scroll FIRST to prevent any layout changes
		theme.initInfiniteScroll();
		
		WebFont.load({
			typekit: {
				id: 'hfr3adq'
			}
		});

		// Mobile menu toggle
		document.querySelector('.menu-toggle')?.addEventListener('click', function() {
			document.documentElement.classList.toggle('menu-open');
			document.querySelector('nav')?.classList.toggle('open');
		});

		// Prevent default on '#' anchors
		document.querySelectorAll('a[href="#"]').forEach(anchor => {
			anchor.addEventListener('click', function(e) {
				e.preventDefault();
			});
		});

		// Sub-menu toggle
		document.querySelectorAll('.menu li.menu-item-has-children > a').forEach(menuItem => {
			menuItem.addEventListener('click', function() {
				const otherMenuItems = document.querySelectorAll('.menu li.menu-item-has-children > a');
				otherMenuItems.forEach(item => {
					if (item !== this) {
						item.classList.remove('open');
						const subMenu = item.nextElementSibling;
						if (subMenu) {
							subMenu.style.display = 'none';
						}
					}
				});
				
				this.classList.toggle('open');
				const subMenu = this.nextElementSibling;
				if (subMenu) {
					subMenu.style.display = subMenu.style.display === 'none' ? 'block' : 'none';
				}
			});
		});

		// Initialize Featherlight Gallery
		const galleryLinks = document.querySelectorAll('.gallery-item a, .pages a');
		if (galleryLinks.length > 0) {
			featherlightGallery(galleryLinks);
		}

		// Animations
		const animateElements = document.querySelectorAll('.animate-on-scroll');
		if (animateElements.length > 0) {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add('animate');
					}
				});
			}, {
				threshold: 0.1
			});

			animateElements.forEach(element => {
				observer.observe(element);
			});
		}

		// Smooth scrolling for page navigation
		setTimeout(() => {
			theme.pageNavSmoothScroll();
		}, 100);
		
		// Handle initial hash in URL
		setTimeout(() => {
			theme.handleInitialHash();
		}, 150);
		
		// Handle browser back/forward navigation
		setTimeout(() => {
			theme.handlePopState();
		}, 200);
	}

	theme.pageNavSmoothScroll = function() {
		// Handle page navigation links with smooth scrolling and section offset fix
		document.querySelectorAll('.page-nav-item').forEach(link => {
			link.addEventListener('click', (e) => {
				const href = link.getAttribute('href');
				const match = href.match(/#(section-\d+)/);
				
				if (match) {
					e.preventDefault();
					
					const sectionId = match[1];
					const sectionNumber = parseInt(sectionId.replace('section-', ''));
					
					// Fix off-by-one error: section-4 link should scroll to section-5 element
					const targetSectionId = `section-${sectionNumber + 1}`;
					
					const targetElement = document.getElementById(targetSectionId);
					
					if (targetElement) {
						// Force layout recalculation
						document.body.offsetHeight;
						
						// Get fresh position after forced reflow
						const refreshedTargetTop = targetElement.offsetTop;
						
						// Determine if header is fixed positioned
						const header = document.querySelector('header');
						const headerStyle = window.getComputedStyle(header);
						const isHeaderFixed = headerStyle.position === 'fixed';
						
						// Calculate header offset only if header is fixed
						let headerOffset = 0;
						if (isHeaderFixed) {
							headerOffset = header.offsetHeight;
						}
						
						const scrollToPosition = Math.max(0, refreshedTargetTop - headerOffset);
						
						// Smooth scroll to target position without updating URL
						window.scrollTo({
							top: scrollToPosition,
							behavior: 'smooth'
						});
					} else {
						// If target +1 section doesn't exist, try the original section
						const fallbackElement = document.getElementById(sectionId);
						if (fallbackElement) {
							window.scrollTo({
								top: fallbackElement.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}
				// If it's not a section anchor link, let the browser handle it normally
			});
		});
	};

	theme.handleInitialHash = function() {
		// Check if there's a hash in the URL when page loads
		if (window.location.hash) {
			const anchorId = window.location.hash.substring(1);
			const targetElement = document.getElementById(anchorId);
			
			if (targetElement) {
				// Small delay to ensure page is fully loaded
				setTimeout(() => {
					const header = document.querySelector('header');
					const headerStyle = header ? window.getComputedStyle(header) : null;
					const isHeaderFixed = headerStyle && (headerStyle.position === 'fixed' || headerStyle.position === 'sticky');
					
					let targetPosition = targetElement.offsetTop;
					
					if (isHeaderFixed && header) {
						const headerHeight = header.offsetHeight;
						const extraOffset = 20;
						targetPosition = targetElement.offsetTop - headerHeight - extraOffset;
					}
					
					window.scrollTo({
						top: Math.max(0, targetPosition),
						behavior: 'smooth'
					});
				}, 100);
			}
		}
	};

	theme.handlePopState = function() {
		// Handle browser back/forward navigation
		window.addEventListener('popstate', function(e) {
			if (window.location.hash) {
				const anchorId = window.location.hash.substring(1);
				const targetElement = document.getElementById(anchorId);
				
				if (targetElement) {
					const header = document.querySelector('header');
					const headerStyle = header ? window.getComputedStyle(header) : null;
					const isHeaderFixed = headerStyle && (headerStyle.position === 'fixed' || headerStyle.position === 'sticky');
					
					let targetPosition = targetElement.offsetTop;
					
					if (isHeaderFixed && header) {
						const headerHeight = header.offsetHeight;
						const extraOffset = 20;
						targetPosition = targetElement.offsetTop - headerHeight - extraOffset;
					}
					
					window.scrollTo({
						top: Math.max(0, targetPosition),
						behavior: 'smooth'
					});
				}
			}
		});
	};

	theme.slideshow = function ($container, $obj={}) {
		if (!$container) return;

        let $args = {
            infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			arrows: false,
			fade: true,
			adaptiveHeight: false,
			lazyLoad: 'ondemand',
			lazyLoadBuffer: 1,
            rows: 0, // fix for v1.8.1 
        };

        $args = Object.assign({}, $args, $obj);
		
		$container.slick($args);

		document.querySelectorAll('button.prev').forEach(button => {
			button.addEventListener('click', () => $container.slick('slickPrev'));
		});
		
		document.querySelectorAll('button.next').forEach(button => {
			button.addEventListener('click', () => $container.slick('slickNext'));
		});
	}

	theme.testimonials = function() {
		// 576px, 768px, 992px, 1200px
		$('.testimonial-list').slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			rows: 0,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1
					}
				},
			]
		});
	};

	theme.accordion = function($container) {
        var accordionItem = $container.find('.accordion__item'),
            accordionHeading = $container.find('.accordion__heading'),
            accordionText = $container.find('.accordion__text');

        accordionText.hide();
        accordionItem.on('click', function () {
            let thisHeading = $(this).find('.accordion__heading'),
                thisText = $(this).find('.accordion__text'),
                openClass = 'item--open';
            // Expand or collapse this panel
            $(thisText).slideToggle(200);
            $(this).toggleClass(openClass);

            // Hide the other panels
            accordionText.not($(thisText)).slideUp(200);
            accordionItem.not($(this)).removeClass(openClass);
        });
    };


	theme.debugSections = function() {
		const sections = document.querySelectorAll('section[id^="section-"]');
		sections.forEach((section, index) => {
			// Section info available for debugging if needed
		});
		
		// Check for duplicate IDs
		const allIds = Array.from(document.querySelectorAll('[id]')).map(el => el.id).filter(id => id.trim() !== '');
		const duplicates = allIds.filter((id, index) => allIds.indexOf(id) !== index);
		if (duplicates.length > 0) {
			duplicates.forEach(dupId => {
				if (dupId && dupId.trim() !== '') {
					const elements = document.querySelectorAll(`#${dupId}`);
					// Duplicate elements found
				}
			});
		}
		
		// Check for all elements with section-4 ID
		const section4Elements = document.querySelectorAll('#section-4');
		// Section-4 elements available for debugging if needed
	};

	theme.initInfiniteScroll = function() {
		const containers = document.querySelectorAll('[data-infinite-scroll]');
		
		containers.forEach(container => {
			const track = container.querySelector('.logos-track');
			if (!track) return;

			// Save original dimensions before any changes
			const originalLogos = Array.from(track.children);
			const containerStyle = window.getComputedStyle(container);
			const originalHeight = container.getBoundingClientRect().height;
			
			// Set container to have fixed dimensions and prevent layout changes
			container.style.height = originalHeight + 'px';
			container.style.overflow = 'hidden';
			container.style.position = 'relative';
			
			// Clone logos for seamless loop
			for (let i = 0; i < 3; i++) {
				originalLogos.forEach(logo => {
					const clone = logo.cloneNode(true);
					track.appendChild(clone);
				});
			}

			let currentX = 0;
			const scrollSpeed = 0.5; // pixels per frame
			const containerWidth = container.offsetWidth;
			const trackWidth = track.scrollWidth;
			const resetPoint = -(trackWidth / 4); // Reset when 1/4 of track has passed

			function animate() {
				currentX -= scrollSpeed;
				
				// Reset position for seamless loop
				if (currentX <= resetPoint) {
					currentX = 0;
				}
				
				track.style.transform = `translateX(${currentX}px)`;
				requestAnimationFrame(animate);
			}

			// Start animation
			animate();

			// Pause on hover
			container.addEventListener('mouseenter', () => {
				track.style.animationPlayState = 'paused';
			});

			container.addEventListener('mouseleave', () => {
				track.style.animationPlayState = 'running';
			});
		});
		
		// Force multiple layout recalculations
		document.body.offsetHeight; // Force reflow
		window.getComputedStyle(document.body).height; // Force style calculation
		
		// Multiple delayed reflows to ensure layout stability
		setTimeout(() => {
			document.body.offsetHeight;
		}, 0);
		
		setTimeout(() => {
			document.body.offsetHeight;
		}, 10);
		
		setTimeout(() => {
			document.body.offsetHeight;
		}, 50);
	};

	// Initialize Shop by Product Buy Tray
	theme.initShopByProduct = function() {
		const section = document.querySelector('.shop-by-product');
		if (!section) return;

		const buyTray = section.querySelector('.buy-tray');
		const productCards = section.querySelectorAll('.product-card');
		let activeButton = null;

		let activeCard = null;

		productCards.forEach(card => {
			const buttons = card.querySelectorAll('.product-card__btn');
			const dataScript = card.querySelector('.product-retailers-data');
			const productName = card.dataset.productName;
			const brandColor = card.dataset.brandColor;
			
			let retailersData = {};
			if (dataScript) {
				try {
					retailersData = JSON.parse(dataScript.textContent);
				} catch (e) {
					console.error('Error parsing retailer data:', e);
				}
			}

			buttons.forEach(btn => {
				btn.addEventListener('click', function(e) {
					e.preventDefault();
					const country = this.dataset.country;
					const data = retailersData[country];

					// Toggle active state
					if (activeButton === this) {
						// Close tray if clicking same button
						buyTray.classList.remove('is-active');
						section.classList.remove('is-tray-active');
						this.classList.remove('is-active');
						card.classList.remove('is-active');
						activeButton = null;
						activeCard = null;
						return;
					}

					// Remove active from previous button and card
					if (activeButton) {
						activeButton.classList.remove('is-active');
					}
					if (activeCard) {
						activeCard.classList.remove('is-active');
					}

					// Set new active button and card
					activeButton = this;
					activeCard = card;
					this.classList.add('is-active');
					card.classList.add('is-active');

					// Update tray content
					updateBuyTray(data, productName, brandColor);
					
					// Show tray and background
					buyTray.classList.add('is-active');
					section.classList.add('is-tray-active');
					
					// Scroll tray into view
					setTimeout(() => {
						buyTray.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
					}, 100);
				});
			});
		});

		function updateBuyTray(data, productName, brandColor) {
			// Update product names
			const productNameSpans = buyTray.querySelectorAll('.product-name');
			productNameSpans.forEach(span => {
				span.textContent = productName;
			});

			// Update brand color
			buyTray.dataset.brandColor = brandColor;

			// Update online retailers
			const onlineSection = buyTray.querySelector('.buy-tray__section--online');
			const onlineLogos = onlineSection.querySelector('.buy-tray__logos');
			onlineLogos.innerHTML = '';
			
			if (data && data.online && data.online.length > 0) {
				onlineSection.style.display = '';
				data.online.forEach(retailer => {
					const link = document.createElement('a');
					link.href = retailer.link;
					link.target = '_blank';
					link.rel = 'noopener noreferrer';
					link.className = 'buy-tray__logo-link';
					
					const img = document.createElement('img');
					img.src = retailer.logo.url;
					img.alt = retailer.logo.alt || 'Retailer logo';
					img.className = 'buy-tray__logo';
					
					link.appendChild(img);
					onlineLogos.appendChild(link);
				});
			} else {
				onlineSection.style.display = 'none';
			}

			// Update in-store retailers
			const instoreSection = buyTray.querySelector('.buy-tray__section--instore');
			const instoreLogos = instoreSection.querySelector('.buy-tray__logos');
			instoreLogos.innerHTML = '';
			
			// Always show the in-store section
			instoreSection.style.display = '';
			
			// Add retailer logos if available
			if (data && data.instore && data.instore.length > 0) {
				data.instore.forEach(retailer => {
					const link = document.createElement('a');
					link.href = retailer.link;
					link.target = '_blank';
					link.rel = 'noopener noreferrer';
					link.className = 'buy-tray__logo-link';
					
					const img = document.createElement('img');
					img.src = retailer.logo.url;
					img.alt = retailer.logo.alt || 'Retailer logo';
					img.className = 'buy-tray__logo';
					
					link.appendChild(img);
					instoreLogos.appendChild(link);
				});
			}

			// Always add "LOCAL STORE" card (with "OR" prefix if there are other retailers)
			const hasRetailers = data && data.instore && data.instore.length > 0;
			const localStoreCard = document.createElement('a');
			localStoreCard.className = 'buy-tray__local-store';
			localStoreCard.href = '#categories_filter';
			localStoreCard.innerHTML = hasRetailers 
				? '<span>OR AT YOUR</span><span>LOCAL STORE</span>'
				: '<span>AT YOUR</span><span>LOCAL STORE</span>';
			localStoreCard.addEventListener('click', function(e) {
				e.preventDefault();
				const target = document.getElementById('categories_filter');
				if (target) {
					const header = document.querySelector('header');
					const headerHeight = header ? header.offsetHeight : 0;
					const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
					window.scrollTo({
						top: Math.max(0, targetPosition),
						behavior: 'smooth'
					});
				}
			});
			instoreLogos.appendChild(localStoreCard);
		}
	};

	// Initialize Store Locator customizations
	theme.initStoreLocator = function() {
		const locatorContainer = document.querySelector('.shop-hero__locator');
		if (!locatorContainer) return;

		// Wait for ASL to load, then customize the UI
		const checkAndReplace = () => {
			const searchGroup = document.querySelector('#asl-storelocator .sl-search-group');

			// Add custom Search button to the search group (keep category filter visible)
			if (searchGroup && !document.querySelector('.asl-search-btn')) {
				const inputField = searchGroup.querySelector('#auto-complete-search');
				
				// Create Search button
				const searchBtn = document.createElement('button');
				searchBtn.type = 'button';
				searchBtn.className = 'asl-search-btn';
				searchBtn.textContent = 'Search';
				searchBtn.addEventListener('click', function() {
					// Trigger the ASL search
					const event = new Event('keyup', { bubbles: true });
					if (inputField) {
						inputField.dispatchEvent(event);
					}
					// Also try triggering the geo button if no input
					if (!inputField.value) {
						const geoBtn = searchGroup.querySelector('.asl-geo');
						if (geoBtn) geoBtn.click();
					}
				});

				// Append only the search button
				searchGroup.appendChild(searchBtn);
			}

			// Hide the geo location modal dialog
			const geoModal = document.querySelector('#asl-storelocator .agile-modal-dialog');
			if (geoModal) {
				geoModal.style.display = 'none';
			}
			
			// Change default category filter text from "None Selected" to "Product Filter"
			const categoryBtn = document.querySelector('#asl-storelocator .categories_filter .multiselect-selected-text');
			if (categoryBtn && categoryBtn.textContent === 'None Selected') {
				categoryBtn.textContent = 'Product Filter';
			}

			// Add map expand/collapse functionality (width-based)
			const mapContainer = document.querySelector('#asl-storelocator .asl-map');
			if (!mapContainer) return;
			
			// Helper function to expand the map - defined globally so it can be used by all event listeners
			const expandMap = function() {
				const container = document.querySelector('#asl-storelocator .asl-map');
				const btn = container ? container.querySelector('.map-expand-btn') : null;
				
				if (container && !container.classList.contains('is-expanded')) {
					container.classList.add('is-expanded');
					if (btn) {
						btn.querySelector('span').textContent = 'Minimize';
						btn.querySelector('svg').innerHTML = '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>';
					}
					
					setTimeout(() => {
						if (window.google && window.google.maps) {
							const mapCanv = document.getElementById('asl-map-canv');
							if (mapCanv && mapCanv.__gm) {
								google.maps.event.trigger(mapCanv.__gm, 'resize');
							}
						}
					}, 550);
				}
			};
			
			// Create expand button if not exists
			if (!mapContainer.querySelector('.map-expand-btn')) {
				const expandBtn = document.createElement('button');
				expandBtn.className = 'map-expand-btn';
				expandBtn.innerHTML = '<span>Full Map</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"></path></svg>';
				
				expandBtn.addEventListener('click', function() {
					mapContainer.classList.toggle('is-expanded');
					const isExpanded = mapContainer.classList.contains('is-expanded');
					expandBtn.querySelector('span').textContent = isExpanded ? 'Minimize' : 'Full Map';
					expandBtn.querySelector('svg').innerHTML = isExpanded 
						? '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>'
						: '<path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"></path>';
					
					setTimeout(() => {
						if (window.google && window.google.maps) {
							const mapCanv = document.getElementById('asl-map-canv');
							if (mapCanv && mapCanv.__gm) {
								google.maps.event.trigger(mapCanv.__gm, 'resize');
							}
						}
					}, 550);
				});
				
				mapContainer.appendChild(expandBtn);
			}

			// Auto-expand when user clicks on map (not on panel or button)
			const storeLocator = mapContainer.querySelector('.store-locator');
			if (storeLocator && !storeLocator.dataset.expandListener) {
				storeLocator.dataset.expandListener = 'true';
				storeLocator.addEventListener('click', function(e) {
					if (e.target.closest('.asl-panel') || e.target.closest('.map-expand-btn')) return;
					expandMap();
				});
			}

			// Auto-expand when user interacts with search input
			const searchInput = document.querySelector('#asl-storelocator #auto-complete-search');
			if (searchInput && !searchInput.dataset.expandListener) {
				searchInput.dataset.expandListener = 'true';
				searchInput.addEventListener('focus', expandMap);
				searchInput.addEventListener('input', expandMap);
				searchInput.addEventListener('keydown', function(e) {
					if (e.key === 'Enter') expandMap();
				});
			}

			// Auto-expand when search button is clicked
			const searchButton = document.querySelector('#asl-storelocator .asl-search-btn');
			if (searchButton && !searchButton.dataset.expandListener) {
				searchButton.dataset.expandListener = 'true';
				searchButton.addEventListener('click', expandMap);
			}

			// Auto-expand when geo location button is clicked
			const geoBtn = document.querySelector('#asl-storelocator .span-geo');
			if (geoBtn && !geoBtn.dataset.expandListener) {
				geoBtn.dataset.expandListener = 'true';
				geoBtn.addEventListener('click', expandMap);
			}

			// Auto-expand when a store item is clicked
			const aslPanel = document.querySelector('#asl-storelocator .asl-panel');
			if (aslPanel && !aslPanel.dataset.expandListener) {
				aslPanel.dataset.expandListener = 'true';
				aslPanel.addEventListener('click', function(e) {
					if (e.target.closest('.sl-item')) expandMap();
				});
			}

			// Auto-expand when category filter is changed
			const categoryFilter = document.querySelector('#asl-storelocator .categories_filter');
			if (categoryFilter && !categoryFilter.dataset.expandListener) {
				categoryFilter.dataset.expandListener = 'true';
				categoryFilter.addEventListener('click', expandMap);
			}
		};

		// Check immediately and then with delay (for ASL lazy loading)
		checkAndReplace();
		setTimeout(checkAndReplace, 500);
		setTimeout(checkAndReplace, 1000);
		setTimeout(checkAndReplace, 2000);
	};

	// Initialize everything when DOM is ready
	$(function() {
		theme.init();
		
		// Initialize other components
		theme.slideshow($('.slide-list'));
		theme.slideshow($('.product-carousel .images.carousel'), {
			// autoplay: true,
			arrows: true
		});
		theme.accordion($('section.accordion'));
		theme.testimonials();
		
		
		// Debug sections after all initialization is complete
		setTimeout(() => {
			theme.debugSections();
		}, 200);

		// Initialize Store Locator customizations
		setTimeout(() => {
			theme.initStoreLocator();
		}, 100);

		// Initialize Shop by Product
		theme.initShopByProduct();
	});
}(jQuery));